import { PropsWithChildren } from 'react'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type IconWrapperProps = PropsWithChildren<
	WithClassName<{
		iconBgColor: string
		iconColor: string
		size?: 'sm' | 'md'
	}>
>

export const IconWrapper = ({
	children,
	iconBgColor,
	iconColor,
	className,
	size = 'md'
}: IconWrapperProps) => (
	<div
		className={cn(
			'grid shrink-0 place-items-center rounded-full [&>svg]:h-4 [&>svg]:w-4 [&>svg]:stroke-2',
			size === 'sm' ? 'h-8 w-8' : 'h-9 w-9',
			iconBgColor,
			iconColor,
			className
		)}>
		{children}
	</div>
)
